<template>
  <div class="banner-bg">
    <carousel
      ref="carouselSelector"
      :navigationEnabled="width > 768 ? true : false"
      :pagination-enabled="false"
      :loop="true"
      :autoplay="true"
      :perPage="1"
      :autoplayTimeout="4000"
      :adjustableHeight="true"
      :autoplayHoverPause="false"
      navigationNextLabel='<img src="/img/website/next.png" alt="avançar">'
      navigationPrevLabel='<img src="/img/website/prev.png" alt="voltar">'
    >
      <slide :style="{height: 'fit-content'}" v-for="(item, index) in items" :key="index">
        <div
          :style="`background-image: url(${item.image});`"
          class="banner"
        ></div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
export default {
  data() {
    return {
      width: screen.width,
      items: [
        {
          image: '/img/website/banner_abril_25.jpg'
        },
        {
          image: '/img/website/banner0.jpg'
        },
        //{
        //  image: '/img/website/banner1.jpg'
        //},
        // {
        //   image: '/img/website/banner3.jpg'
        // }
      ]
    }
  },
  components: {
    Carousel,
    Slide,
  },
  methods: {
    scrollBottom () {
      // document.querySelector('.home-products').scrollIntoView({ behavior: 'smooth' })
      const element = document.querySelector('.home-products')
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
      const offsetPosition = elementPosition - 100
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  },
  mounted() {
    setTimeout(() => {
      this.$refs['carouselSelector'].onResize()
      this.$refs['carouselSelector'].goToPage(0)
      document.getElementById("loadingHome").style.display = "none";
    }, 200)
  },
}
</script>

<style lang="scss" scoped>
@import "resources/assets/sass/website/_variables.scss";
.banner {
  height: calc(100vh - 60px);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  @media (max-width: 767px) {
    height: 350px;
  }
}
.welcome-video {
  height: calc(100vh - 60px)!important;
}
</style>